import { getItemUrl, getImageUrl } from 'utils/utils';
import Link from 'next/link';
import type { Item } from 'types';
import IconArrowLeft from 'components/IconArrowLeft';
import IconArrowRight from 'components/IconArrowRight';
import Picture from 'components/Picture';

type ProductNavigationLinkProps = {
  product: Item;
  direction: 'next' | 'previous';
};

const ProductNavigationLink = ({ product, direction }: ProductNavigationLinkProps) => {
  const isPrevious = direction === 'previous';

  return (
    <div>
      <h3 className={`text-h5 mb-8 text-gray-dark ${isPrevious ? '' : 'text-right'}`}>{direction}</h3>

      <Link href="/collection/[category]/[slug]" as={getItemUrl(product)}>
        <a
          className={`
            tracker-cta-product-${isPrevious ? 'prev' : 'next'}-190417-093850 ease-hover flex 
            flex-col space-y-16 border-1 border-gray p-16 transition-all duration-150 hover:bg-white hover:shadow-3 sm:space-x-32 sm:space-y-0
            ${
              isPrevious ? 'items-end sm:flex-row-reverse sm:space-x-reverse' : 'items-start sm:flex-row'
            } sm:items-center
          `}
        >
          <div className="leading-none">
            <Picture
              url={getImageUrl(product, 'PDP_Hero')!}
              alt={`${product.display_name} preview`}
              className="aspect-ratio-7by5 sm:aspect-ratio-1by1"
              focalPointY={0}
              srcSet={{
                lg: 60,
                md: 60,
                sm: 60,
                xs: 160,
                base: 230,
              }}
            />
          </div>

          <div className={`flex flex-col space-y-8 ${isPrevious ? 'items-end' : 'items-start'}`}>
            <h4 className={`text-h5 ${isPrevious ? 'text-right' : ''}`}>{product.display_name}</h4>

            <p
              className={`flex space-x-8 leading-none text-gold-darker ${
                isPrevious ? 'flex-row text-right' : 'flex-row-reverse'
              } items-center`}
            >
              {isPrevious ? (
                <IconArrowLeft className="mr-4 !text-gold-darker" />
              ) : (
                <IconArrowRight className="ml-4 !text-gold-darker" />
              )}
              View Product
            </p>
          </div>
        </a>
      </Link>
    </div>
  );
};

export default ProductNavigationLink;
